<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-row :span="2" style="margin-top: 30px;">
              名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              图片:<el-input v-model="img" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>
           

          <el-row :span="2" style="margin-top: 30px;">
              <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
          </el-row>
      </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="100"
              label="名称"
               >
               <template slot-scope="scope">
                  <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="150"
              label="图片地址"
               >
              <template slot-scope="scope">
            
                <div  @click="dischange(scope.row.img,scope.row.id,2)">{{scope.row.img}}</div>
              </template>
            </el-table-column>
            <el-table-column

              width="100"
              label="图片"
               >
              <template slot-scope="scope">

                <img style="width: 60px;height: 60px;"  :src="scope.row.img" class="avatar">
              </template>
            </el-table-column>
			<el-table-column
			
			  width="70"
			  label="ids"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.ids,scope.row.id,3)">{{scope.row.ids}}</div>
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="200"
			  label="分类"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.fenlei,scope.row.id,4)">{{scope.row.fenlei}}</div>
			  </template>
			</el-table-column>	
			<el-table-column
			
			  width="70"
			  label="id"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.idz,scope.row.id,5)">{{scope.row.idz}}</div>
			  </template>
			</el-table-column>
            <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>
				   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="dischange(scope.row.name,scope.row.id,1)">修改名称</el-col>	
                 </el-row>
               </template>
            </el-table-column>
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
	
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         img:'',
         names:'',
         disDialogVisible:false,
				 x_id:this.$route.query.id,	
		 
         changeId:0,
         t:0,
         addImg:'',
         addImgs:'',
         imageId:0,
         seachName:'',
         imgId:0



      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
	
	
	
	to(id){
	  const x_id = this.x_id	
	  this.$router.push({ name:'Xingxiangm', query: { id: id,x_id:x_id }})
	},  
    seach(){
      this.loadList();
    },
    
    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimizChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
		  x_id:this.x_id
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimiz_list'
      })
      .then(res=>{
		this.count = res.data.count;
        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
              item['lables'] = item['lable'].split(',');
        })
        


      })
      .catch(err=>{

      });
    },




    del(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimizDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
       


      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimizAdd',
      	params:{
      		name:this.name,
            img:this.img,
      		x_id:this.x_id

      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/xingxiangzhimiz.vue